import { render, staticRenderFns } from "./UserPlanCredits.vue?vue&type=template&id=5f830cea"
import script from "./UserPlanCredits.vue?vue&type=script&lang=js"
export * from "./UserPlanCredits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports